import { Pipe, PipeTransform } from '@angular/core';
import { ConfigurationObject, DEFAULT_CONFIG_NAME } from '../store/configuration.datamodel';

@Pipe({
    name: 'configurationNames',
    standalone: false
})
export class ConfigurationNamesPipe implements PipeTransform {
  transform(entities: ConfigurationObject[], sep = ', '): string | undefined {
    if (entities.length === 0) {
      return undefined;
    }
    return entities
      .map(config => config?.name ?? DEFAULT_CONFIG_NAME)
      .join(sep);
  }
}
